import { API_BASE_URL } from "src/config/apiBase";

const TOKEN_KEY = "portalAccessToken";

/** Same-origin in local dev so setupProxy forwards /portal/* to the API. */
function portalApiBase() {
  if (typeof window !== "undefined" && process.env.NODE_ENV === "development") {
    const host = window.location.hostname || "";
    if (host === "localhost" || host === "127.0.0.1") {
      return "";
    }
  }
  return API_BASE_URL;
}

export function getPortalToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

export function setPortalToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

function authHeaders() {
  const token = getPortalToken();
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function parseJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    throw new Error("Unexpected server response");
  }
}

export async function portalSendOtp(email, mainId) {
  const res = await fetch(`${portalApiBase()}/portal/auth/send-otp`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, main_id: mainId }),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(data.message || "Could not send code");
  return data;
}

export async function portalVerifyOtp(email, otp, mainId) {
  const res = await fetch(`${portalApiBase()}/portal/auth/verify-otp`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, otp, main_id: mainId }),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(data.message || "Verification failed");
  if (data.accessToken) setPortalToken(data.accessToken);
  return data;
}

export async function portalFetchMe() {
  const res = await fetch(`${portalApiBase()}/portal/auth/me`, {
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(data.message || "Session expired");
  return data;
}

export async function portalFetchInvoices(filter = "all") {
  const res = await fetch(
    `${portalApiBase()}/portal/invoices?filter=${encodeURIComponent(filter)}`,
    { headers: authHeaders() }
  );
  const data = await parseJson(res);
  if (!res.ok) throw new Error(data.message || "Could not load invoices");
  return data.invoices || [];
}

export async function portalFetchReceipts() {
  const res = await fetch(`${portalApiBase()}/portal/receipts`, {
    headers: authHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(data.message || "Could not load receipts");
  return data.receipts || [];
}

export async function portalCreatePayLink(invoiceId) {
  const res = await fetch(`${portalApiBase()}/portal/invoices/${invoiceId}/pay-link`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({}),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(data.message || "Could not create pay link");
  return data;
}

export function portalLogout() {
  setPortalToken("");
}
